import React from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTabQuery } from 'hooks/useQueryState'
import AppListTabPanel from './AppListTabPanel'
import { APP_LIST_CONFIGS } from './listConfigs'

export default function AppLists() {
  const [tab, setTab] = useTabQuery('appListsTab', 'template-new')

  return (
    <Tabs
      value={tab}
      onValueChange={setTab}
      className="flex h-[calc(100vh-98px)] min-h-[640px] flex-col"
    >
      <div className="flex shrink-0 items-center gap-8">
        <h2 className="text-3xl font-bold tracking-tight">App Lists</h2>
        <TabsList>
          {APP_LIST_CONFIGS.map((item) => (
            <TabsTrigger key={item.id} value={item.id}>
              {item.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      {APP_LIST_CONFIGS.map((item) => (
        <TabsContent
          key={item.id}
          value={item.id}
          className="mt-4 min-h-0 flex-1 data-[state=inactive]:hidden"
        >
          {tab === item.id ? <AppListTabPanel config={item} /> : null}
        </TabsContent>
      ))}
    </Tabs>
  )
}
